"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationList = void 0;
const three_1 = require("three");
const AnnotationForm_1 = require("./AnnotationForm");
const PubSub = __importStar(require("pubsub-js"));
class AnnotationList {
    constructor(webgl, annotationService, apiService, hasEditor) {
        this.itemList = [];
        this._isEditable = false;
        this.defaultColor = new three_1.Color(255, 255, 255).convertSRGBToLinear();
        this.editableColor = new three_1.Color(255, 255, 0).convertSRGBToLinear();
        this.eventSubscriptionNames = [];
        this.webgl = webgl;
        this.annotationService = annotationService;
        this.parentEl = document.getElementById('annotationControl');
        if (!this.parentEl) {
            throw new Error('Undefined element annotationControl');
        }
        if (hasEditor) {
            this.annotationForm = new AnnotationForm_1.AnnotationForm(this.annotationService, apiService); // TODO: check if editor is enabled to create this
        }
        this.createEvents();
    }
    get selectedItemId() { return this._selectedItemId; }
    set selectedItemId(selectedItemId) { this._selectedItemId = selectedItemId; }
    get isEditable() { return this._isEditable; }
    set isEditable(isEditable) {
        if (isEditable) {
            if (this.annotationForm) {
                this.annotationForm.isVisible = true;
            }
            this.itemList.forEach((item) => {
                // if (item.manualId !== this._selectedItemId) item.annotationHotspot.element.material.color = this.editableColor;
            });
        }
        else {
            if (this.annotationForm) {
                this.annotationForm.isVisible = false;
            }
            this.itemList.forEach((item) => {
                // if (item.manualId !== this._selectedItemId) item.annotationHotspot.element.material.color = this.defaultColor;
            });
        }
        this._isEditable = isEditable;
    }
    /**
     * Get item
     * @param manualId
     * @returns
     */
    get(manualId) {
        return this.annotationService.get(manualId);
    }
    /**
     * List items
     * @returns
     */
    list() {
        return this.itemList;
    }
    /**
     * Add item
     * @param item
     * @returns
     */
    add(annotation) {
        var _a, _b;
        (_b = (_a = this.annotationForm) === null || _a === void 0 ? void 0 : _a.annotationTextEditor) === null || _b === void 0 ? void 0 : _b.createAnnotation(annotation);
        this.hideOnEmptyList();
        return annotation;
    }
    /**
     * Update item
     * @param updatedItem
     * @returns
     */
    edit(props) {
        var _a, _b, _c;
        const annotationIndex = this.annotationService.annotations.findIndex((ann) => ann.manualId === props.manualId);
        if (annotationIndex === -1) {
            console.log('Item not found - manualId: ' + props.manualId);
            return null;
        }
        const annotation = this.annotationService.annotations[annotationIndex];
        const cameraPosition = this.webgl.camera.position;
        annotation.orderNumber = (_a = props.orderNumber) !== null && _a !== void 0 ? _a : 0;
        annotation.name = (_b = props.name) !== null && _b !== void 0 ? _b : '';
        annotation.content = (_c = props.content) !== null && _c !== void 0 ? _c : '';
        annotation.cameraPoint.x = cameraPosition.x;
        annotation.cameraPoint.y = cameraPosition.y;
        annotation.cameraPoint.z = cameraPosition.z;
        const annotationInterface = {
            manualId: annotation.manualId,
            annotationPoint: annotation.annotationPoint,
            cameraPoint: annotation.cameraPoint,
            content: annotation.content,
            name: annotation.name,
            orderNumber: annotation.orderNumber,
            url: annotation.url,
            id: annotation.id
        };
        annotation.annotationHotspot.updatePosition(annotationInterface);
        annotation.annotationPopover.updatePosition(annotationInterface);
        this.annotationService.annotations.splice(annotationIndex, 1, annotation);
        this.webgl.renderOnce();
        this.hideOnEmptyList();
        return annotation;
    }
    /**
     * Remove item
     * @param manualId
     * @returns
     */
    remove(manualId) {
        const annotationIndex = this.annotationService.annotations.findIndex(ann => ann.manualId === manualId);
        if (annotationIndex === -1) {
            console.log('Item not found: ' + manualId);
            return null;
        }
        const annotation = this.annotationService.annotations[annotationIndex];
        annotation.dispose();
        this.annotationService.removeAnnotationByIndex(annotationIndex);
        this.hideOnEmptyList();
        this.webgl.renderOnce();
        return manualId;
    }
    //Update position of annotation on object movement
    updatePosition(data) {
        const current = data.current;
        const initial = data.initial;
        this.annotationService.annotations.forEach(annotation => {
            const position = new three_1.Vector3(annotation.annotationPoint.x, annotation.annotationPoint.y, annotation.annotationPoint.z);
            const positionDelta = new three_1.Vector3(current.position.x - initial.position.x, current.position.y - initial.position.y, current.position.z - initial.position.z);
            position.x += data.delta.position.x;
            position.y += data.delta.position.y;
            position.z += data.delta.position.z;
            const rotationPosition = new three_1.Vector3(position.x - positionDelta.x, position.y - positionDelta.y, position.z - positionDelta.z);
            const resetRotation = new three_1.Euler().setFromQuaternion(new three_1.Quaternion().setFromEuler(data.delta.rotation).invert());
            rotationPosition.applyEuler(resetRotation);
            rotationPosition.applyEuler(current.rotation);
            position.x = rotationPosition.x + positionDelta.x;
            position.y = rotationPosition.y + positionDelta.y;
            position.z = rotationPosition.z + positionDelta.z;
            const cameraPoint = new three_1.Vector3(annotation.cameraPoint.x + data.delta.position.x, annotation.cameraPoint.y + data.delta.position.y, annotation.cameraPoint.z + data.delta.position.z);
            const cameraRotationPosition = new three_1.Vector3(cameraPoint.x - positionDelta.x, cameraPoint.y - positionDelta.y, cameraPoint.z - positionDelta.z);
            cameraRotationPosition.applyEuler(resetRotation);
            cameraRotationPosition.applyEuler(current.rotation);
            cameraPoint.x = cameraRotationPosition.x + positionDelta.x;
            cameraPoint.y = cameraRotationPosition.y + positionDelta.y;
            cameraPoint.z = cameraRotationPosition.z + positionDelta.z;
            const annotationInterface = {
                manualId: annotation.manualId,
                annotationPoint: position,
                cameraPoint: cameraPoint,
                content: annotation.content,
                name: annotation.name,
                orderNumber: annotation.orderNumber,
                url: annotation.url,
                id: annotation.id
            };
            annotation.annotationHotspot.updatePosition(annotationInterface);
            annotation.annotationPopover.updatePosition(annotationInterface);
            annotation.cameraPoint = cameraPoint;
            annotation.annotationPoint = position;
        });
        this.webgl.renderOnce();
    }
    /**
     * Show selected item or hide all with id null
     * @param manualId
     */
    show(manualId) {
        this.annotationService.show(manualId);
    }
    saveToList(item) {
        this.annotationService.saveToList(item);
    }
    /**
     * Change camera position and target to the selected hotspot
     * @param annotation
     */
    goToHotSpot(annotation) {
        this.annotationService.goToHotSpot(annotation);
    }
    /**
     * Get the highest annotation order number
     * First orderNumber should be 0, it will fail on orderNumber[ 0, 1, 3 ]
     * @returns
     */
    getHighestOrderNumber() {
        return this.annotationService.getHighestOrderNumber();
    }
    /**
     * Create events
     */
    createEvents() {
        const annotationAdd = PubSub.subscribe("annotation-added" /* ANNOTATION_ADDED */, (_, annotation) => this.add(annotation));
        this.eventSubscriptionNames.push(annotationAdd);
        // Subscribe to annotation-manage event
        const annotationManage = PubSub.subscribe("annotation-manage" /* ANNOTATION_MANAGE */, () => {
            this.isEditable = !this.isEditable;
            this.webgl.renderOnce();
        });
        this.eventSubscriptionNames.push(annotationManage);
        const annotationUpdate = PubSub.subscribe("annotation-update" /* ANNOTATION_UPDATE */, (_, data) => this.edit(data));
        this.eventSubscriptionNames.push(annotationUpdate);
        // Subscribe to annotation remove
        const annotationRemove = PubSub.subscribe("annotation-remove" /* ANNOTATION_REMOVE */, (_, annManualId) => this.remove(annManualId));
        this.eventSubscriptionNames.push(annotationRemove);
        //Sunscribe to annotation show
        const annotationShow = PubSub.subscribe("show-annotation" /* ANNOTATION_SHOW */, (_, data) => this.show(data));
        this.eventSubscriptionNames.push(annotationShow);
        //Subscribe to update annotation position
        const annotaionPositionUpdate = PubSub.subscribe("update annotation position in space" /* UPDATE_ANNOTATION_POSITION_IN_SPACE */, (_, data) => this.updatePosition(data));
        this.eventSubscriptionNames.push(annotaionPositionUpdate);
    }
    /**
     * Remove events
     */
    removeEvents() {
        this.eventSubscriptionNames.forEach((eventSubscriptionName, index, object) => {
            if (eventSubscriptionName) {
                PubSub.unsubscribe(eventSubscriptionName);
            }
            object.splice(index, 1);
        });
    }
    hideOnEmptyList() {
        if (this.parentEl) {
            this.parentEl.style.display = this.annotationService.annotations.length > 0 ? 'block' : 'none';
        }
    }
}
exports.AnnotationList = AnnotationList;
